 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"WidgetSeeMore":"WidgetSeeMore","budgetData":"budgetData","dashboard":"dashboard","settings":"settings","changePassword~passwordRecovery~registration":"changePassword~passwordRecovery~registration","changePassword":"changePassword","passwordRecovery":"passwordRecovery","addAccount":"addAccount","addCategory":"addCategory","registration":"registration","addBudget":"addBudget","editBudget":"editBudget","addTransaction~editTransaction":"addTransaction~editTransaction","addTransaction":"addTransaction","editTransaction":"editTransaction","profile":"profile","editAccount":"editAccount","login":"login","dashboardHome":"dashboardHome","editCategory":"editCategory","error":"error","extensions":"extensions","help":"help","issues":"issues","mainNav":"mainNav","notificationSingle":"notificationSingle","notifications":"notifications","passwordChanged":"passwordChanged","reminders":"reminders","suggestions":"suggestions","viewAccounts~viewBudgets~viewCategory~viewExpense~viewIncomes~viewTransaction~viewTransfer":"viewAccounts~viewBudgets~viewCategory~viewExpense~viewIncomes~viewTransaction~viewTransfer","viewAccounts":"viewAccounts","viewBudgets":"viewBudgets","viewCategory":"viewCategory","viewExpense":"viewExpense","viewIncomes":"viewIncomes","viewTransaction":"viewTransaction","viewTransfer":"viewTransfer"}[chunkId]||chunkId) + "." + {"WidgetSeeMore":"34d19251","budgetData":"eac19bbb","chunk-2f51647c":"43497f62","dashboard":"0006262b","chunk-633d020a":"1c657aa9","settings":"76d7a9fb","chunk-71c5bad0":"3fa9edf2","changePassword~passwordRecovery~registration":"1ffc70e6","changePassword":"3dfaa3d5","passwordRecovery":"98114185","chunk-35d75fec":"47d1e228","addAccount":"acda5978","addCategory":"bdf46765","chunk-1180eb81":"5434b81a","registration":"e5da3242","addBudget":"6a4e8fdb","editBudget":"db4ad0f0","chunk-a60283a8":"9f03a820","addTransaction~editTransaction":"dbf7454a","addTransaction":"9f328770","editTransaction":"e3aa0b48","profile":"c009b7e0","editAccount":"e5e13d3c","login":"431b0fff","dashboardHome":"2d29eaca","editCategory":"f631f03d","error":"78973862","extensions":"c1c43908","help":"0f01d23c","issues":"d329103c","mainNav":"c6eb58aa","notificationSingle":"4d610a4b","notifications":"2f720781","passwordChanged":"058a26ea","reminders":"2ad8dcdb","suggestions":"252d8a01","viewAccounts~viewBudgets~viewCategory~viewExpense~viewIncomes~viewTransaction~viewTransfer":"85c74135","viewAccounts":"38eb2ab8","viewBudgets":"5171bcdb","viewCategory":"19d18709","viewExpense":"8f74c6bf","viewIncomes":"32ecfe8d","viewTransaction":"ab011a2b","viewTransfer":"f44723ec","chunk-2d0a4f01":"f8e8802f","chunk-65b20a09":"8f50f23f","chunk-65e21587":"f04859ad","chunk-341114f5":"157f3274","chunk-b5ae4504":"de3b441b","chunk-11b0097c":"75c28457","chunk-2d0b2128":"a661c037","chunk-2d237b07":"3898c265","chunk-11de202f":"86a31abd","chunk-2d22c19d":"d4e8a9bf","chunk-d0366a16":"cac28a22","chunk-2d0b6abf":"4a3a1895","chunk-2d0dd840":"3ca99847","chunk-30e1c9e8":"975abd04","chunk-422a73bc":"1dc15d9b","chunk-542a3c56":"389afcf5","chunk-2d0a405e":"fcfbff5f","chunk-2d0da924":"5d782ea4","chunk-2d207ecb":"43e491f1","chunk-361a7dc0":"febe6efc","chunk-2d0c5583":"79e2c267","chunk-3f842dee":"4ab228ff","chunk-3f35d0c2":"9f22c2fe","chunk-e82fb778":"718692db","chunk-6299fd94":"b74216af","chunk-26022510":"0a88cd26","chunk-302fb255":"911c32e4","chunk-51f08d5a":"e25a4794","chunk-05a7aaff":"638f8b7f","chunk-9983abee":"0abbff47","chunk-2c96af89":"ef8c8c49","chunk-2d225f2c":"fd9dd75a","chunk-ece3ad5a":"9e853f60","chunk-4be97e27":"8181327d","chunk-9898f8b8":"163d4960","chunk-5ae20cc1":"83407e33","chunk-806bcdd8":"a0a8dde6","chunk-86435190":"6c9eb2f6","chunk-2d0ab4b9":"f4989601","chunk-2d0e5f63":"39a062f6","chunk-2d20903c":"9a63dca2","chunk-2d21d4ee":"dd9e9d5c","chunk-3050df7a":"10ff3e7d","chunk-5c827148":"a0a2b8e6","chunk-3ae781a0":"9d87983e","chunk-2d0c2080":"dc046dfb","chunk-2d0c7932":"1a5602af","chunk-2d0dad42":"9ad36885","chunk-35591854":"a065f987","chunk-4c1433a9":"848f3447","chunk-511752b6":"49c30d9c","chunk-cf79b014":"acdf382f","chunk-2d0b8e39":"cc6b4757","chunk-2d22d9c9":"e213017e","chunk-f51c0d88":"c987de57","chunk-f9868d8a":"94ba4e37","chunk-fa7dce02":"e142bf3a","chunk-7ca53e68":"dd896f18","chunk-085275d0":"3c2992d4","chunk-7185d62d":"b1c825a2","chunk-6473c307":"24ff4c15","chunk-3511d47c":"7534d520","chunk-0669f262":"2cd57d97","chunk-07eef290":"f83df5e7","chunk-2d0e1bfa":"bac551fd","chunk-2d0ab8cb":"eec5f46e","chunk-522a8ca9":"ddc06cd6","chunk-73b6b390":"99a81425"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-2f51647c":1,"dashboard":1,"chunk-633d020a":1,"chunk-71c5bad0":1,"changePassword":1,"passwordRecovery":1,"chunk-35d75fec":1,"addAccount":1,"addCategory":1,"chunk-1180eb81":1,"registration":1,"addBudget":1,"editBudget":1,"chunk-a60283a8":1,"addTransaction~editTransaction":1,"profile":1,"editAccount":1,"login":1,"error":1,"viewAccounts~viewBudgets~viewCategory~viewExpense~viewIncomes~viewTransaction~viewTransfer":1,"chunk-65b20a09":1,"chunk-65e21587":1,"chunk-341114f5":1,"chunk-b5ae4504":1,"chunk-11b0097c":1,"chunk-11de202f":1,"chunk-d0366a16":1,"chunk-30e1c9e8":1,"chunk-422a73bc":1,"chunk-542a3c56":1,"chunk-361a7dc0":1,"chunk-3f842dee":1,"chunk-3f35d0c2":1,"chunk-e82fb778":1,"chunk-6299fd94":1,"chunk-26022510":1,"chunk-302fb255":1,"chunk-51f08d5a":1,"chunk-05a7aaff":1,"chunk-2c96af89":1,"chunk-ece3ad5a":1,"chunk-4be97e27":1,"chunk-9898f8b8":1,"chunk-5ae20cc1":1,"chunk-806bcdd8":1,"chunk-86435190":1,"chunk-3050df7a":1,"chunk-5c827148":1,"chunk-3ae781a0":1,"chunk-35591854":1,"chunk-4c1433a9":1,"chunk-511752b6":1,"chunk-cf79b014":1,"chunk-f51c0d88":1,"chunk-f9868d8a":1,"chunk-fa7dce02":1,"chunk-7ca53e68":1,"chunk-7185d62d":1,"chunk-6473c307":1,"chunk-522a8ca9":1,"chunk-73b6b390":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"WidgetSeeMore":"WidgetSeeMore","budgetData":"budgetData","dashboard":"dashboard","settings":"settings","changePassword~passwordRecovery~registration":"changePassword~passwordRecovery~registration","changePassword":"changePassword","passwordRecovery":"passwordRecovery","addAccount":"addAccount","addCategory":"addCategory","registration":"registration","addBudget":"addBudget","editBudget":"editBudget","addTransaction~editTransaction":"addTransaction~editTransaction","addTransaction":"addTransaction","editTransaction":"editTransaction","profile":"profile","editAccount":"editAccount","login":"login","dashboardHome":"dashboardHome","editCategory":"editCategory","error":"error","extensions":"extensions","help":"help","issues":"issues","mainNav":"mainNav","notificationSingle":"notificationSingle","notifications":"notifications","passwordChanged":"passwordChanged","reminders":"reminders","suggestions":"suggestions","viewAccounts~viewBudgets~viewCategory~viewExpense~viewIncomes~viewTransaction~viewTransfer":"viewAccounts~viewBudgets~viewCategory~viewExpense~viewIncomes~viewTransaction~viewTransfer","viewAccounts":"viewAccounts","viewBudgets":"viewBudgets","viewCategory":"viewCategory","viewExpense":"viewExpense","viewIncomes":"viewIncomes","viewTransaction":"viewTransaction","viewTransfer":"viewTransfer"}[chunkId]||chunkId) + "." + {"WidgetSeeMore":"31d6cfe0","budgetData":"31d6cfe0","chunk-2f51647c":"d7df91b3","dashboard":"774b92b9","chunk-633d020a":"b97556e2","settings":"31d6cfe0","chunk-71c5bad0":"046842e1","changePassword~passwordRecovery~registration":"31d6cfe0","changePassword":"4b7f13da","passwordRecovery":"8515cc25","chunk-35d75fec":"f3fc1ecf","addAccount":"d3de4bc2","addCategory":"d3de4bc2","chunk-1180eb81":"d3de4bc2","registration":"330e0c86","addBudget":"d3de4bc2","editBudget":"d3de4bc2","chunk-a60283a8":"8ee10342","addTransaction~editTransaction":"0e4b090e","addTransaction":"31d6cfe0","editTransaction":"31d6cfe0","profile":"a16fa804","editAccount":"d3de4bc2","login":"8515cc25","dashboardHome":"31d6cfe0","editCategory":"31d6cfe0","error":"df7e54c5","extensions":"31d6cfe0","help":"31d6cfe0","issues":"31d6cfe0","mainNav":"31d6cfe0","notificationSingle":"31d6cfe0","notifications":"31d6cfe0","passwordChanged":"31d6cfe0","reminders":"31d6cfe0","suggestions":"31d6cfe0","viewAccounts~viewBudgets~viewCategory~viewExpense~viewIncomes~viewTransaction~viewTransfer":"9e682c69","viewAccounts":"31d6cfe0","viewBudgets":"31d6cfe0","viewCategory":"31d6cfe0","viewExpense":"31d6cfe0","viewIncomes":"31d6cfe0","viewTransaction":"31d6cfe0","viewTransfer":"31d6cfe0","chunk-2d0a4f01":"31d6cfe0","chunk-65b20a09":"606ed9bb","chunk-65e21587":"606ed9bb","chunk-341114f5":"04699255","chunk-b5ae4504":"291264f7","chunk-11b0097c":"19094ea5","chunk-2d0b2128":"31d6cfe0","chunk-2d237b07":"31d6cfe0","chunk-11de202f":"1fea6533","chunk-2d22c19d":"31d6cfe0","chunk-d0366a16":"18fec022","chunk-2d0b6abf":"31d6cfe0","chunk-2d0dd840":"31d6cfe0","chunk-30e1c9e8":"3dc9ceb2","chunk-422a73bc":"62987a4e","chunk-542a3c56":"455b74d7","chunk-2d0a405e":"31d6cfe0","chunk-2d0da924":"31d6cfe0","chunk-2d207ecb":"31d6cfe0","chunk-361a7dc0":"8cd46748","chunk-2d0c5583":"31d6cfe0","chunk-3f842dee":"5cdb3f48","chunk-3f35d0c2":"6561e0f6","chunk-e82fb778":"d3de4bc2","chunk-6299fd94":"02be971f","chunk-26022510":"5c7cf0ca","chunk-302fb255":"84ce17a1","chunk-51f08d5a":"84ce17a1","chunk-05a7aaff":"18fec022","chunk-9983abee":"31d6cfe0","chunk-2c96af89":"18a091a7","chunk-2d225f2c":"31d6cfe0","chunk-ece3ad5a":"8cd46748","chunk-4be97e27":"da90d451","chunk-9898f8b8":"b1c7e67b","chunk-5ae20cc1":"8632ec41","chunk-806bcdd8":"3aa04e19","chunk-86435190":"8632ec41","chunk-2d0ab4b9":"31d6cfe0","chunk-2d0e5f63":"31d6cfe0","chunk-2d20903c":"31d6cfe0","chunk-2d21d4ee":"31d6cfe0","chunk-3050df7a":"606ed9bb","chunk-5c827148":"cca85635","chunk-3ae781a0":"0643e3c5","chunk-2d0c2080":"31d6cfe0","chunk-2d0c7932":"31d6cfe0","chunk-2d0dad42":"31d6cfe0","chunk-35591854":"02be971f","chunk-4c1433a9":"9bb75be4","chunk-511752b6":"02be971f","chunk-cf79b014":"4d7b4523","chunk-2d0b8e39":"31d6cfe0","chunk-2d22d9c9":"31d6cfe0","chunk-f51c0d88":"76d0fa83","chunk-f9868d8a":"76d0fa83","chunk-fa7dce02":"e9f2d047","chunk-7ca53e68":"c4658311","chunk-085275d0":"31d6cfe0","chunk-7185d62d":"46111584","chunk-6473c307":"4b7f13da","chunk-3511d47c":"31d6cfe0","chunk-0669f262":"31d6cfe0","chunk-07eef290":"31d6cfe0","chunk-2d0e1bfa":"31d6cfe0","chunk-2d0ab8cb":"31d6cfe0","chunk-522a8ca9":"a112bb4b","chunk-73b6b390":"43dad6c3"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
